export default {
  FETCH_ARTICLE_LIST: 'FETCH_ARTICLE_LIST',
  FETCH_ARTICLE_LIST_SUCCESS: 'FETCH_ARTICLE_LIST_SUCCESS',
  FETCH_ARTICLE_LIST_FAILURE: 'FETCH_ARTICLE_LIST_FAILURE',

  FETCH_ARTICLE_LIST_RELATED_COMMUNITIES: 'FETCH_ARTICLE_LIST_RELATED_COMMUNITIES',
  FETCH_ARTICLE_LIST_RELATED_COMMUNITIES_SUCCESS: 'FETCH_ARTICLE_LIST_RELATED_COMMUNITIES_SUCCESS',
  FETCH_ARTICLE_LIST_RELATED_COMMUNITIES_FAILURE: 'FETCH_ARTICLE_LIST_RELATED_COMMUNITIES_FAILURE',

  FETCH_ARTICLE_LIST_RELATED_TAGS: 'FETCH_ARTICLE_LIST_RELATED_TAGS',
  FETCH_ARTICLE_LIST_RELATED_TAGS_SUCCESS: 'FETCH_ARTICLE_LIST_RELATED_TAGS_SUCCESS',
  FETCH_ARTICLE_LIST_RELATED_TAGS_FAILURE: 'FETCH_ARTICLE_LIST_RELATED_TAGS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/articles/articleList/actionTypes.js